import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/upakovka/icon/warning.svg")